import {PriceFilterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/filter_section.types';
import {FilterLabels} from '@aboutyou/legacy-tracking-sdk';
import {FilterDropdownPrice} from '@aboutyou/ui-components';
import React, {FC} from 'react';
import {usePriceFilterSection} from '../../shared/usePriceFilterSection';

type Props = {
  activeFilters: Map<string, Array<string> | undefined>;
  data: PriceFilterSection;
  resetFilters: (slugs: Array<string>) => void;
  setFilter: (filterData: {
    filterId: string;
    filterSection: string;
    singleSelectOnly?: boolean;
  }) => void;
  onOpen: (filterSlug: string, label: FilterLabels) => void;
  onClose: (filterSlug: string, label: FilterLabels) => void;
  filterLabel: FilterLabels;
};

export const FilterSectionPrice: FC<Props> = ({
  activeFilters,
  data,
  resetFilters,
  setFilter,
  onOpen,
  onClose,
  filterLabel,
}) => {
  const {
    priceSlider,
    totalMax,
    totalMin,
    slug,
    setValues,
    values,
    handleApplyPriceRange,
    hasAppliedPriceRange,
    currencyCode,
  } = usePriceFilterSection({
    data,
    activeFilters,
    setFilter,
  });

  if (!priceSlider || !slug || !totalMax) {
    return null;
  }

  return (
    <FilterDropdownPrice
      label={priceSlider.label}
      max={totalMax}
      min={totalMin}
      onApply={handleApplyPriceRange}
      onChange={(range: [number, number]) => setValues(range)}
      values={values}
      onFilterReset={() => resetFilters([slug])}
      hasAppliedPriceRange={hasAppliedPriceRange}
      currencyCode={currencyCode}
      onOpen={() => onOpen(slug, filterLabel)}
      onClose={() => onClose(slug, filterLabel)}
    />
  );
};
